import routes from 'utils/routes';
import useSimulator from './useSimulator';

function useSimulatorRoutes() {
  const simulator = useSimulator();
  return routes(simulator);
}

export default useSimulatorRoutes;
